/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Nav_App_Uploads_RemainingInputs */

const en_nav_app_uploads_remaining = /** @type {(inputs: Nav_App_Uploads_RemainingInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} upload remaining`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} uploads remaining`);
	return /** @type {LocalizedString} */ ("nav_app_uploads_remaining");
};

const es_nav_app_uploads_remaining = /** @type {(inputs: Nav_App_Uploads_RemainingInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} subida restante`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} subidas restantes`);
	return /** @type {LocalizedString} */ ("nav_app_uploads_remaining");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} upload remaining" |
* | "other" | "{count} uploads remaining" |
*
* @param {Nav_App_Uploads_RemainingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_uploads_remaining = /** @type {((inputs: Nav_App_Uploads_RemainingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Uploads_RemainingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_uploads_remaining(inputs)
	return en_nav_app_uploads_remaining(inputs)
});